module.exports = __webpack_public_path__ + "images/defaultProfileIcon-37496d07ae91ed5a5d556950c6cc664e.svg";